import React from 'react';
import {
  useGetNpsCampaignResultsBuslines,
  useGetNpsCampaignResultsSchedules,
} from '@area-restrita/api-client/endpoints/nps/nps.gen';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import NpsResultsSegmentTable from './NpsResultsSegmentTable';

interface IProps {
  campaignId: string;
}

const RESULT_SEGMENT_LIMIT = 100;

const NpsResultsSegmentsTabs: React.FC<IProps> = ({ campaignId }) => {
  const buslinesQuery = useGetNpsCampaignResultsBuslines(campaignId, {
    id: campaignId,
    page: 1,
    limit: RESULT_SEGMENT_LIMIT,
  });
  const schedulesQuery = useGetNpsCampaignResultsSchedules(campaignId, {
    id: campaignId,
    page: 1,
    limit: RESULT_SEGMENT_LIMIT,
  });

  const hasError = buslinesQuery.isError || schedulesQuery.isError;

  return (
    <div className="flex flex-col gap-3">
      {hasError && (
        <Alert variant="destructive">
          <AlertDescription>
            Não foi possível carregar os resultados por linha e horário. Tente
            novamente.
          </AlertDescription>
        </Alert>
      )}

      <Tabs defaultValue="buslines">
        <TabsList>
          <TabsTrigger value="buslines">Linhas</TabsTrigger>
          <TabsTrigger value="schedules">Horários</TabsTrigger>
        </TabsList>
        <TabsContent value="buslines">
          <NpsResultsSegmentTable
            kind="busline"
            segments={buslinesQuery.data?.data ?? []}
            isLoading={buslinesQuery.isLoading}
          />
        </TabsContent>
        <TabsContent value="schedules">
          <NpsResultsSegmentTable
            kind="schedule"
            segments={schedulesQuery.data?.data ?? []}
            isLoading={schedulesQuery.isLoading}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default NpsResultsSegmentsTabs;
